import { useMediaQuery } from '@chakra-ui/react';
import { theme } from '../../assets/style/theme';

type Props = {
  fallback?: string;
};

function LineBreakOnMobile({ fallback }: Props) {
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <>
      <br style={{ display: `${isMobile ? 'inline' : 'none'}` }} />
      {fallback && !isMobile && (`${fallback}`)}
    </>
  );
}

LineBreakOnMobile.defaultProps = {
};

export default LineBreakOnMobile;
